import React from 'react';
import { resourceApi } from '../utils/fetchUtil';
import HeaderSmall from '../Components/Header/HeaderSmall';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { logSsoClick } from '../actions/logActions';
import { cdnPath } from '../constants/config';

class SsoPage extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
          samlToken: null,
          postUrl: null,
          relayState: null,
          showFormPost: false,
          showButton: true
        };
      }

    componentDidMount() {

        try{
            this.getToken();

            if(!window.cordova || !window.cordova.InAppBrowser){
                this.setState({ showFormPost: true});
            }
        }
        catch(err) {
            //alert("error");
        }
    }

    getToken = () => {

        var self = this;

        let config = {
            method: 'get',
            url: `member/sso/healthaxis`
        };
 
       resourceApi(config) 
        .then(function (response) {
            self.setState({ 
                samlToken: response.data.AuthPayload, 
                postUrl: response.data.Url, 
                relayState: response.data.RelayState,
                ssoProviderId: response.data.SsoProviderID 
            });    
        })
        .catch(function (error) {
            console.log(error);
            self.setState({ 
                showButton: false
            });
        });
    }

    ssoGo = () => {
       
        var self = this;

        logSsoClick(this.state.ssoProviderId);

        if(window.cordova.InAppBrowser){

            var pageContent = '<html><head></head><body><form id="ssoForm" action="' + this.state.postUrl + '" method="post">' +
                '<input type="hidden" name="SamlResponse" value="' + this.state.samlToken + '">' +
                '<input type="hidden" name="RelayState" value="' + this.state.relayState + '">' +
                '</form> <script type="text/javascript">document.getElementById("ssoForm").submit();</script></body></html>';
                
            var pageContentUrl = 'data:text/html;base64,' + btoa(pageContent);

            var browserRef = window.cordova.InAppBrowser.open(
                pageContentUrl ,
                "_blank",
                "hidden=no,location=no,clearsessioncache=yes,clearcache=yes"
            );
            browserRef.addEventListener('exit', 
                function(){
                    window.screen.orientation.unlock(); 
                    self.getToken();
                });
            
            browserRef.executeScript({"code":pageContentUrl});

            window.screen.orientation.lock('landscape');
        }
    }

    render() {

        const buttonStyle = {borderRadius: 15, width:285, textTransform:'none', fontSize:18, height:45, backgroundColor: getMuiTheme(window.muiTheme).palette.primary1Color, color:"#fff", border: 0};

        return (
            <div>
                <div style={{backgroundColor:'#fff', marginTop:-15}}>
                    <HeaderSmall title="Claims & EOBs" />
                    <div className="container treuno" >
                        <div className="container treunoLight" style={{textAlign:'center'}}>
                            <img style={{height: "200px"}} src={`https://${cdnPath}/brands/healthchoice/caeob.PNG`} />
                            <br />
                            <div style={{width:'320px', margin: '0 auto', textAlign:'left' }} >
                                <h2 style={{fontWeight:'normal', fontSize:'18pt'}}>Access Claims and EOBs!</h2>
                                <br />
                                <div className="treunoLight"  >
                                    <span style={{lineHeight:'23px'}}>Tap the button below to view your claims or EOBs (Explanation of Benefits) on HealthChoice Connect (we’ll sign you in automatically).</span>
                                    <br />
                                    <br />
                                    <span>You can:
                                        <ul style={{lineHeight:'23px'}}>
                                            <li>View claims</li>
                                            <li>View & download EOBs</li>
                                            <li>Verify other insurance coverage and more...</li>
                                        </ul>    
                                    </span>                                
                                </div>
                            </div>
                            {this.state.showButton && (
                                <div>
                                    {this.state.showFormPost && (
                                        <form method="post" action={this.state.postUrl} > 
                                            <input type="hidden" name="SAMLResponse" value={this.state.samlToken} /> 
                                            <input type="hidden" name="RelayState" value={this.state.relayState} /> 
                                            <button style={buttonStyle}>
                                                <label>View Claims & EOBs</label>
                                            </button>
                                        </form>
                                    )}
                                    {!this.state.showFormPost && (
                                        <button onClick={this.ssoGo} style={buttonStyle}>
                                            <label>View Claims & EOBs</label>
                                        </button>
                                    )}
                                </div>
                            )}
                            {!this.state.showButton && (
                                <div>
                                    <h3 style={{ color: "red" }}>An error occurred.</h3>
                                    <p>Please contact support to resolve the issue.</p>
                                </div>
                            )}
                            <br />
                            <div style={{width:'295px', margin: '0 auto'}}>
                                <span style={{ color: "red", fontSize:14 }}>If you have not created an account on HealthChoice Connect, you will be redirected to the sign up page to complete your registration.</span>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};
export default SsoPage;


// WEBPACK FOOTER //
// ./src/Pages/Sso.js